import { render } from "./EditProject.vue?vue&type=template&id=35efdc7c&scoped=true"
import script from "./EditProject.vue?vue&type=script&lang=js"
export * from "./EditProject.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-35efdc7c"

export default script